import { capitalize } from 'vue';

import i18n from '@/vueI18n';

export default class CreativeFormatOptions {
  static options() {
    return [
      {
        id: 'audio',
        name: capitalize(i18n.global.t('messages.audio')),
      },
      {
        id: 'html',
        name: capitalize(i18n.global.t('messages.html')),
      },
      {
        id: 'image',
        name: capitalize(i18n.global.t('names.image', { n: 1 })),
      },
      {
        id: 'video',
        name: capitalize(i18n.global.t('names.video', { n: 1 })),
      },
      {
        id: 'zip',
        name: capitalize(i18n.global.t('messages.zip')),
      },
    ];
  }
}
